import script from "./DownFile.vue?vue&type=script&lang=ts&name=PDFViewer&setup=true"
export * from "./DownFile.vue?vue&type=script&lang=ts&name=PDFViewer&setup=true"

import "./DownFile.vue?vue&type=style&index=0&id=07b4a135&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b4a135"]])

export default __exports__